import React, { useState } from 'react';

import SupplyChainNav from '../../../components/supply-chain/nav.js';
import ContainerSelect from '../../../components/supply-chain/container-select.js';
import ContainerTimelineView from '../../../components/supply-chain/container-timeline-view.js';
import { Col } from '@shadcn/components/ui/col.jsx';
import { Card, CardContent as CardBody } from '@shadcn/components/ui/card.jsx';

// Container event timeline — pick a container by ref to see its events.
const ContainerTimeline = ({ match }) => {
  const [containerId, setContainerId] = useState(match?.params?.containerID || '');

  return (
    <SupplyChainNav>
      <div>
        <Col className="w-full">
          <Card className="pt-6 mb-10">
            <CardBody>
              <h4 className="mb-3">Container Timeline</h4>
              <div className="mb-4" style={{ maxWidth: 520 }}>
                <ContainerSelect value={containerId} onChange={setContainerId} />
              </div>

              {containerId ? (
                <ContainerTimelineView containerId={containerId} />
              ) : (
                <p className="text-muted-foreground">Search for a container to see its event timeline.</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </div>
    </SupplyChainNav>
  );
};

export default ContainerTimeline;
